import React from "react";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { THEME_CONFIG } from "./configs/AppConfig";
import store from "./redux/store";
import Views from "./views";
import { clarity } from 'react-microsoft-clarity';
import EnvColorTheme from "components/layout-components/EnvColorTheme";
import { UserProfilesProvider } from "context/UserProfileContext";
import UsageTracker from "components/tracking/UsageTracker";
import ErrorBoundary from "components/tracking/ErrorBoundary";
import { initToastTracking } from "services/ToastTrackingService";
import { initGlobalErrorTracking } from "services/UsageTrackingService";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  clarity.init("he2idepqew");
  clarity.consent();
  initToastTracking();
  initGlobalErrorTracking();
  return (
    <div className="App">
      <Provider store={store}>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <EnvColorTheme>
            <UserProfilesProvider>
              <Router>
                <UsageTracker />
                <ErrorBoundary>
                  <Switch>
                    <Route path="/" component={Views} />
                  </Switch>
                </ErrorBoundary>
              </Router>
            </UserProfilesProvider>
          </EnvColorTheme>
        </ThemeSwitcherProvider>
      </Provider>
    </div>
  );
}

export default App;
